module.exports = __webpack_public_path__ + "loader-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/loader-logo.png
// module id = 1242
// module chunks = 322